
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-fill",attrs:{"fill":"#CDF5F1"}},[_c('path',{attrs:{"d":"M7.363 23.701a5.77 5.77 0 0 0-3.058 5.097 5.77 5.77 0 0 0 5.766 5.772h11.145v-3.864l-3.222-2.013a2.37 2.37 0 0 1-.491-1.444V22.01c0-.864.47-1.66 1.226-2.075l4.95-2.72a2.36 2.36 0 0 1 1.209-.292c1.691.978 4.763 2.788 4.838 3.297a2.37 2.37 0 0 1 1.183 2.05v5.143c0 .846-.451 1.627-1.183 2.05l-4.653 2.647v2.46h16.132a5.77 5.77 0 0 0 5.765-5.773 5.77 5.77 0 0 0-4.254-5.572c1.827-5.546-3.68-11.316-9.387-9.506-1.276-3.568-4.684-6.121-8.687-6.121-4.714 0-8.601 3.54-9.157 8.108-4.477-.382-8.427 3.519-8.122 7.994"}}),_c('path',{attrs:{"d":"M22.913 23.66a1.574 1.574 0 1 1 .001-3.15 1.574 1.574 0 0 1-.002 3.15"}})]),_c('path',{staticClass:"i-cloud",attrs:{"stroke":"#234652","d":"M16.57 32.996H7.345a5.77 5.77 0 0 1-5.765-5.772 5.77 5.77 0 0 1 3.529-5.322c-.637-4.654 3.415-8.9 8.07-8.504.555-4.569 4.443-8.108 9.157-8.108 4.003 0 7.41 2.553 8.687 6.121 6.08-1.929 11.657 4.65 9.086 10.275a5.77 5.77 0 0 1 4.136 5.538 5.77 5.77 0 0 1-5.766 5.772h-8.281"}}),_c('path',{staticClass:"i-key",attrs:{"fill-rule":"evenodd","stroke":"#234652","d":"M24.095 16.466a2.36 2.36 0 0 0-2.365 0l-4.45 2.571a2.37 2.37 0 0 0-1.181 2.05v5.144c0 .845.45 1.627 1.182 2.05l3.935 2.274v10.507c0 .968 1.097 1.527 1.878.956l1.043-.76c.305-.223.486-.579.486-.957v-1.192c.686-.21 1.455-.443 1.455-1.322v-2.026c0-.866-.759-1.106-1.431-1.338l-.024-.008v-3.868l3.921-2.266a2.37 2.37 0 0 0 1.182-2.05v-5.144c0-.845-.45-1.627-1.182-2.05zm-1.182 7.193a1.575 1.575 0 1 0-.002-3.149 1.575 1.575 0 0 0 .002 3.15Z","clip-rule":"evenodd"}})])
          )
        }
      }
    